import { render, staticRenderFns } from "./PlayerScoreCard.vue?vue&type=template&id=65988a54&scoped=true&"
import script from "./PlayerScoreCard.vue?vue&type=script&lang=js&"
export * from "./PlayerScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayerScoreCard.vue?vue&type=style&index=0&id=65988a54&lang=scss&scoped=true&"
import style1 from "./PlayerScoreCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65988a54",
  null
  
)

export default component.exports